import { observer } from "mobx-react-lite";
import { DealStatus } from "../../interfaces/IDeal";
import { formatNumber, formatPrice } from "../../utils/utils";
import infoStyles from "../Info.module.css";
import DealStatusWithIcon from "./DealStatusWithIcon";

function DealInfo({ name, value, status, stageId, buildingSize, landSizeAcres, zoning, className, onClick }: IDealInfoProps) {
    return (
        <div className={[infoStyles.container, className].join(" ")} onClick={onClick}>
            <div className={infoStyles.title}>{name}</div>
            <div className={infoStyles.description}>
                <DealStatusWithIcon status={status} stageId={stageId} /> - {!!value && formatPrice(value)}
            </div>
            <div className={infoStyles.description}>
                {[
                    !!buildingSize && `${formatNumber(buildingSize)} Sq-Ft`,
                    !!landSizeAcres && `${formatNumber(landSizeAcres)} Acres`,
                    !!zoning && `${zoning} Zoning`,
                ].filter(d => d).join(" - ")}
            </div>
        </div>
    );
}

export interface IDealInfoProps {
    name: string;
    value: number;
    status: DealStatus;
    stageId: number;
    buildingSize: number | null;
    landSizeAcres: number | null;
    zoning: string | null;
    className?: string;
    onClick?: () => void;
}

export default observer(DealInfo);